export default class MarcheTrancheDto {
  libelle;
  validee;
  objectifPme;
  objectifInsertion;
  montantGlobal;
}